import { render, staticRenderFns } from "./CategoryVideo.vue?vue&type=template&id=82a61f90&"
import script from "./CategoryVideo.vue?vue&type=script&lang=js&"
export * from "./CategoryVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports